export default __webpack_public_path__ + "static/media/can-testing.3524e5e2.jpg";